// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ry1J","content":"styles_content__3mJpi","tableWrap":"styles_tableWrap__3Coyg"};